import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-footer',
    imports: [],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent {
  @Input() url: string = '';

  isHomePage: boolean = this.onHomePage();
  isLoginPage: boolean = this.onLoginPage();
  isHostedPortalPage: boolean = this.onHostedPortalPage();
  copyWright: string = `${new Date().getFullYear()} SoftPro`;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['url']) {
      // Get changes from input variable from parent
      this.isHomePage = this.onHomePage();
      this.isLoginPage = this.onLoginPage();
      this.isHostedPortalPage = this.onHostedPortalPage();
    }
  }
  
  onHomePage() {
    return this.url == "/";
  }
  onLoginPage() {
    return this.url.startsWith("/login")
              || this.url.startsWith("/signin")
  }
  onHostedPortalPage() {
    return this.url == "/hosted-portal";
  }
  
}
